/**
 * Создает кастомное событие с возможностью подписки на него
 *
 * @typeParam Payload - Тип данных, которые могут быть переданы вместе с событием
 * @returns Событие с методами `.subscribe()` и `.publish()` для подписки на событие и отправки нового события
 *
 * @example
 * // Создание события
 * const someEvent = createEvent<{ someField: string }>();
 *
 * // Подписка на событие
 * someEvent.subscribe(payload => {
 *     console.log(payload.someField);
 * });
 *
 * // Отправка события
 * someEvent.publish({ someField: 'someValue' });
 */
export function createEvent() {
    let eventHandlers = [];
    return {
        publish(...args) {
            for (const eventHandler of eventHandlers) {
                eventHandler(...args);
            }
        },
        subscribe(eventHandler) {
            eventHandlers.push(eventHandler);
            return function unsubscribe() {
                eventHandlers = eventHandlers.filter(storedEventHandler => storedEventHandler !== eventHandler);
            };
        },
    };
}
